import React from 'react'
import { connect } from 'react-redux'
import { FeedbackFormField } from 'common/views/components/FeedbackFormField'
import { ToggleShowLastNote } from './ToggleShowLastNote'
import { updateNote, checkNoteValid } from 'manager/redux/referral_status'
import { withRouter } from 'react-router'
import { scrollToTop } from 'manager/util/helper'

const NoteTextInput = ({ updateNote, note, error, checkNoteValid, location }) => {
  const type = location.query.editstatus

  const onChange = evt => {
    updateNote(evt.target.value)
    checkNoteValid({ type, payload: { note: evt.target.value } })
  }

  return (
    <div>
      <ToggleShowLastNote title="What&apos;s Changed?" />
      <FeedbackFormField isRequired={true} errorMsg={error} dataTestId="Note">
        <textarea className="form-control" onChange={onChange} value={note} onFocus={scrollToTop} />
      </FeedbackFormField>
    </div>
  )
}

const selector = state => {
  const note = _.get(state, ['referralStatus', 'note'], '')
  const validationAttempted = _.get(state, ['referralStatus', 'validationAttempted'], false)
  const error = !_.get(state, ['referralStatus', 'validNote'], !validationAttempted)

  return {
      note,
      error,
  }
}

const actions = {
  updateNote,
  checkNoteValid,
}

const withRedux = connect(selector, actions)

export const NoteField = withRedux(withRouter(NoteTextInput))
